import type { FunctionComponent } from 'react';

import { useBalance } from '../../../account/hooks/use-balance';
import { LargeTopNavigation as LargeTopNavigationComponent } from '../../components/large-top-navigation/large-top-navigation';

export interface ILargeTopNavigationProps {
    className?: string;
    hideNavigationActions?: boolean;
}

export const LargeTopNavigation: FunctionComponent<ILargeTopNavigationProps> = ({ className }) => {
    const { wallets } = useBalance();

    return <LargeTopNavigationComponent className={className} wallets={wallets} />;
};
